import { Button } from "@sellar-io/components";
import { useIntercom } from "react-use-intercom";

export const BusinessRegistrationSubmitted = ({
  onDone,
}: {
  onDone: () => void;
}) => {
  const intercom = useIntercom();

  return (
    <div className="pt-8:md mx-auto max-w-xl px-6 pb-16 text-center">
      {/* Success Icon */}
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
        <svg
          className="h-8 w-8 text-green-600"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* Heading */}
      <h1 className="mb-4 text-2xl font-semibold">Application submitted</h1>

      <p className="mb-8 text-gray-700">
        Your business registration application has been successfully submitted.
      </p>

      <h1 className="mb-4 text-2xl font-semibold">Next steps</h1>

      <p className="mb-4 font-semibold text-gray-700">
        1. You will receive an email from Two Inc. requesting that you submit
        evidence related to your application. As part of this process, Two will
        also need to review your bank account.
        <br />{" "}
        <strong>
          Please ensure you provide details for your primary business or
          personal bank account, with a transaction history of at least the last
          6 months.
        </strong>{" "}
        Newly opened or temporary accounts cannot be accepted for verification.
      </p>

      <p className="mb-4 text-gray-700">
        2. We’ll review your business details and notify you within the next 24
        hours once your business registration is complete.
      </p>

      <p className="mb-6 text-gray-700">
        3. After your business has been registered, we’ll automatically carry
        out a credit check to assess your eligibility for Sellar Credit. We’ll
        notify you of the outcome as soon as this process is complete.
      </p>

      <p className="mb-6 text-gray-700">
        Should you need any additional support regarding your application don't
        hesitate to reach via the contact support button below or anywhere else
        in the app
      </p>

      <div className="flex w-full justify-center gap-2">
        <Button size="large" onClick={onDone}>
          Return
        </Button>

        <Button color={"secondary"} onClick={() => intercom.show()}>
          Contact support
        </Button>
      </div>
    </div>
  );
};
